import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'reactstrap';

import MuiIcon from 'components/Icons/MuiIcon';

function Login2FAAnotherMethod(props) {
  const {
    enabledOTP,
    enabledEmail,
    enabledAltEmail,
    onShowAuth,
    onShowEmail,
    onShowAltEmail,
    onBack,
  } = props;

  return (
    <React.Fragment>
      <div className="text-center">
        <h1>2-Factor Authentication</h1>
        <h1>Other methods</h1>

        <p>
          Having trouble?
          <br />
          Try one of these alternative method to log in.
        </p>
      </div>

      {enabledOTP && (
        <Button outline block onClick={onShowAuth}>
          Use Authenticator
        </Button>
      )}

      {enabledEmail && (
        <Button outline block onClick={onShowEmail}>
          Send code to email
        </Button>
      )}

      {enabledAltEmail && (
        <Button outline block onClick={onShowAltEmail}>
          Send a code to secondary email
        </Button>
      )}

      <Button tag={Link} to="/contact" outline block>
        Get help from IAF Certsearch Support Team
      </Button>

      <div className="mt-5 text-center">
        <Button
          color="link"
          className="p-0 font-weight-normal"
          onClick={onBack}
        >
          Go back
          <MuiIcon name="arrow_back" />
        </Button>
      </div>
    </React.Fragment>
  );
}

export default Login2FAAnotherMethod;
